module.exports = __webpack_public_path__ + "img/ownerChannel_crown.fd16c28d.svg";